import React from 'react'
export const compound_circle_color = {
  path: (
    <>
      <path
        d="M16 29.3332C23.3638 29.3332 29.3333 23.3636 29.3333 15.9998C29.3333 8.63604 23.3638 2.6665 16 2.6665C8.63616 2.6665 2.66663 8.63604 2.66663 15.9998C2.66663 23.3636 8.63616 29.3332 16 29.3332Z"
        fill="url(#comp_paint0_linear)"
        key="s9d_l1Ofz"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.97538 20.4698C9.57694 20.2261 9.33325 19.7921 9.33325 19.326V16.7237C9.33325 16.6241 9.35993 16.5281 9.40974 16.4427C9.56449 16.1759 9.90779 16.0852 10.1746 16.2417L16.048 19.6658C16.3913 19.8668 16.603 20.2332 16.603 20.6316V23.3282C16.603 23.451 16.5692 23.5737 16.5052 23.6786C16.3113 23.9953 15.8986 24.0949 15.582 23.901L9.97538 20.4698ZM18.7303 15.5284C19.0736 15.7294 19.2853 16.0959 19.2853 16.4943V21.9657C19.2853 22.1276 19.1981 22.277 19.0576 22.3553L17.7716 23.0792C17.7556 23.0881 17.7378 23.0952 17.72 23.1006V20.0625C17.72 19.6693 17.5137 19.3047 17.1757 19.1019L12.0174 16.0158V12.5864C12.0174 12.4868 12.0441 12.3907 12.0939 12.3054C12.2486 12.0385 12.5919 11.9478 12.8587 12.1044L18.7303 15.5284ZM21.3007 11.4871C21.6457 11.6864 21.8574 12.0563 21.8574 12.4548V20.4467C21.8574 20.6103 21.7667 20.7615 21.6226 20.8398L20.4041 21.4979V15.934C20.4041 15.5409 20.1978 15.178 19.8617 14.9752L14.5894 11.8126V8.55932C14.5894 8.45971 14.6161 8.36366 14.6642 8.27828C14.8189 8.01147 15.1622 7.92075 15.429 8.0755L21.3007 11.4871Z"
        fill="white"
        key="qN5zCckNXJ"
      />
      <linearGradient
        id="comp_paint0_linear"
        key="comp_paint0_linear"
        x1="25.1705"
        y1="22.9999"
        x2="6.67053"
        y2="8.49988"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00D395" key="-YCHvu4fgY" />
        <stop offset="1" stopColor="#27AC85" key="Ta9lnQsHgw" />
      </linearGradient>
    </>
  ),
  viewBox: '0 0 32 32',
}
